import { useEffect, useState } from "react";
import { _BusinessProcess, _DocumentatioPage, _HelpDesk, _Inbox, _single, _SystemPropertyOB } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../hooks/useModal";
import { Modal } from "../../../Modal";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { BasicButton } from "../../../BasicButton";
import { SelectDocumentatioPage } from "../../../../../admin/menu/DocumentatioPage/SelectDocumentatioPage";
import { ModalConfirm } from "../../../ModalConfirm";
import { EditorDocumentatioPage } from "../../../../../admin/menu/DocumentatioPage/EditorDocumentatioPage";
import { Alert } from "../../../Alert";
import "./DocumentationButton.css"


interface ComponentData {
    canEdit?: Boolean;
}

export const DocumentationButton = ({ canEdit }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_DocumentatioPage);
    const miga = useParams();
    const { module, view } = miga;

    const MenUrl = module && view ? `/${module}/${view}` : null;
    const [response, setResponse] = useState<any>("");

    const modal = useModal("", MODAL_XL);
    const modalA = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Documentación", MODAL_SM);


    useEffect(() => {
        if(MenUrl){
            getLista()
        }
    }, [module, view])

    const getLista = () => {
        let props: any = {
            ApplicationIDUrl: `=${MenUrl}`
        }
        instance.getPageDocumentationRender(null, null, props).then(
            (resp) => {
                setLista(resp.List)
                setResponse("");
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const getDocumentInfo = (idPage: number) => {
        instance.getPageDocumentationHtml(idPage).then(
            (resp) => {
                setResponse(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            ApplicationIDUrl: MenUrl,
            LastUpdate: _single.getCurrenDate(),
        });
        modalA.open("Agregar Documentación");
    }

    const deleteItem = () => {
        instance.deleteDocumentatioPage(bean.IDDocumentatioPage).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    };

    const editaItem = (obj: any) => {
        instance.updateDocumentatioPage(obj).then(
            (resp: any) => {
                getLista();
                modalA.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const dataform = () => {
        return (
            <>
                <button title="Documentación" type="button" onClick={() => { modal.open("Documentos Adjuntos"); }} className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                    <i className="ri-file-mark-line fs-22"></i>
                </button>

                <Modal modal={modal.modal} updateModal={modal.setModal}>
                    <div className="row">
                        <div className="col-md-4 border-end pe-3">
                            <div className="row">
                                <div className="col-md-12">
                                    {canEdit &&
                                        <div className="col-md-4 mb-2">
                                            <BasicButton eventClick={() => { create() }} icon="ri-file-add-line" children={`Agregar`} />

                                            <Modal modal={modalA.modal} updateModal={modalA.setModal} eventModal={() => { editaItem({ ...bean, IDEmployee: _single.getAccountID(), LastUpdate: _single.getCurrenDate() }) }} >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <EditorDocumentatioPage IDSelect={bean.IDBookPage} onChange={(e) => { setBean({ ...bean, IDBookPage: e?.PageID, PageName: e?.Name }) }} label="Documentos Disponibles" />
                                                    </div>
                                                </div>
                                            </Modal>
                                        </div>
                                    }
                                </div>

                                <div className="col-md-12">
                                    <div className="list-group" style={{ maxHeight: "52vh", overflow: "auto" }}>

                                        {Array.isArray(lista) && lista.length > 0 &&
                                            lista.map((item: any, index: number) => {
                                                const DataItem = item.DataBeanProperties;
                                                return (
                                                    <div
                                                        key={index}
                                                        className="list-group-item d-flex justify-content-between align-items-center pointer"
                                                        onClick={() => {
                                                            if (DataItem.IDBookPage) {
                                                                setBean(DataItem);
                                                                getDocumentInfo(DataItem.IDBookPage);
                                                            } else {
                                                                toast.error("Validar configuración")
                                                            }
                                                        }}
                                                    >
                                                        <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                                            <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                            {index + 1} - {DataItem.PageName}
                                                        </span>
                                                        {canEdit &&
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setBean(DataItem);
                                                                    modalC.open();
                                                                }}
                                                            >
                                                                <i className="ri-close-line"></i>
                                                            </button>
                                                        }
                                                    </div>
                                                );
                                            })
                                        }

                                    </div>
                                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                                        <strong>Eliminar Documento {bean.PageName}</strong>
                                    </ModalConfirm>
                                </div>
                            </div>
                        </div>
                        {response ?
                            <div className="col-md-8">
                                <iframe
                                    srcDoc={response}
                                    style={{ width: "100%", height: "75vh" }}
                                />
                            </div>
                            :
                            <div className="col-md-8">
                                <Alert children={`Debe seleccionar un Documento`} clase="info" />
                            </div>
                        }
                    </div>
                </Modal>
            </>
        )
    }

    return (lista.length > 0 || canEdit) && dataform();
}